export const RESULT_TABS = {
  DASHBOARD: 1,
  ACTIVITY_LOG: 2,
  MERCHANT_LIST: 3,
  USER_LIST: 4,
} as const;

export type ResultTab = (typeof RESULT_TABS)[keyof typeof RESULT_TABS];
